import {
    fetchGetApplication,
    fetchGetApplicationsDocumentReviewFeedback,
    fetchGetDocumentUpload
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import { TDocuments } from '../../../../tradingData/TradingDataHelper';

export const useGetDocumentFeedback = () => {
    const stateKey = useStateKey();

    const { data: applicationResponse } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () =>
            fetchGetApplication({
                stateKey
            }),
        suspense: true
    });

    const { data: documentsResponse } = useQuery({
        queryKey: ['documents', stateKey, true],
        queryFn: () =>
            fetchGetDocumentUpload({
                stateKey,
                query: { append_feedback: true }
            }),
        suspense: true
    });

    if (!applicationResponse || !documentsResponse) {
        throw new Error('Data fetching error');
    }

    const applicationId = applicationResponse.data?.application_id;
    const isDocumentReviewEnabled = Boolean(applicationId);

    const { data: documentReviewResponse, isError: documentReviewError } =
        useQuery({
            queryKey: ['document_review_feedback', stateKey, applicationId],
            queryFn: () =>
                fetchGetApplicationsDocumentReviewFeedback({
                    applicationId: applicationId!
                }),
            suspense: true,
            enabled: isDocumentReviewEnabled
        });

    if (
        isDocumentReviewEnabled &&
        (!documentReviewResponse || documentReviewError)
    ) {
        throw new Error('Data fetching error');
    }

    const { additional_info_requests, doc_requirement_reviews } =
        documentReviewResponse?.data || {};

    const documents = (documentsResponse.data ?? []) as unknown as TDocuments;

    const hasDocumentFeedback =
        (additional_info_requests?.length ?? 0) > 0 ||
        (doc_requirement_reviews?.length ?? 0) > 0 ||
        documents.some(
            (doc) => (doc.attributes?.document_feedback?.length ?? 0) > 0
        );

    return {
        hasDocumentFeedback
    };
};
